import { Ratio, Size } from "../../../constants";

export enum CROPPER_STEP {
    rectangle = 'rectangle',
    square = 'square',
    review = 'review',
}

export const CROPPER_ORDER = [
    CROPPER_STEP.rectangle,
    CROPPER_STEP.square,
    CROPPER_STEP.review,
];

export const AcceptedMimes = 'image/jpeg,image/png,image/webp';

export const CropperStepIdOrder = [
    CROPPER_STEP.rectangle,
    CROPPER_STEP.square,
    CROPPER_STEP.rectangle,
];

export const getCropperSteps = (
    setStep: (step: CROPPER_STEP) => void
) => (
    [
        {
            id: CROPPER_STEP.rectangle,
            label: 'Rectangle',
            onClick: () => setStep(CROPPER_STEP.rectangle),
            onSubmit: () => setStep(CROPPER_STEP.square),
        },
        {
            id: CROPPER_STEP.square,
            label: 'Square',
            onClick: () => setStep(CROPPER_STEP.square),
            onBack: () => setStep(CROPPER_STEP.rectangle),
            onSubmit: () => setStep(CROPPER_STEP.review),
        },
        {
            id: CROPPER_STEP.review,
            label: 'Review',
            onClick: () => setStep(CROPPER_STEP.review),
            onBack: () => setStep(CROPPER_STEP.square),
            onSubmit: () => console.log('todo'),
        },
    ]
);

export const getCropperStep = (
    setStep: (step: CROPPER_STEP) => void
) => (
    [
        {
            id: CROPPER_STEP.square,
            label: 'Square',
            onClick: () => setStep(CROPPER_STEP.square),
            onBack: () => setStep(CROPPER_STEP.rectangle),
            onSubmit: () => setStep(CROPPER_STEP.review),
        }
    ]
);

export const getSizeClasses = (sizeOptions?: { size?: Size, ratio?: Ratio, isPlaceholder?: boolean }) => {
    const isPlaceholder = sizeOptions?.isPlaceholder;
    const isSquare = sizeOptions?.ratio === Ratio.square;
    let sizeClasses: string;

    switch (sizeOptions?.size) {
        case Size.xs:
            sizeClasses = `w-[75px] ${isPlaceholder ? 'h-[75px]' : 'max-h-[75px]'}`;  // Square only, no 16:10 equivalent
            break;
        case Size.sm:
            sizeClasses = isSquare ? `w-[150px] ${isPlaceholder ? 'h-[150px]' : 'max-h-[150px]'}` : `w-[150px] ${isPlaceholder ? 'h-[94px]' : 'max-h-[94px]'}`;  // 16:10 ratio
            break;
        case Size.lg:
            sizeClasses = isSquare ? `w-[600px] ${isPlaceholder ? 'h-[600px]' : 'max-h-[600px]'}` : `w-[600px] ${isPlaceholder ? 'h-[375px]' : 'max-h-[375px]'}`;  // 16:10 ratio
            break;
        case Size.xl:
            sizeClasses = `w-[900px] ${isPlaceholder ? 'h-[563px]' : 'max-h-[563px]'}`;  // 16:10 ratio, no square equivalent
            break;
        default:
            sizeClasses = isSquare ? `w-[300px] ${isPlaceholder ? 'h-[300px]' : 'max-h-[300px]'}` : `w-[300px] ${isPlaceholder ? 'h-[188px]' : 'max-h-[188px]'}`;  // 16:10 ratio
    }

    return sizeClasses;
};


export type ImageId = {
    referralImageId?: string;
    userImageId?: string;
    productImageId?: string;
    backgroundTheme?: { themeId: string, subThemeId?: string };
};
